/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `daily` - daily
 * @export
 */
export const PeriodicEnum = {
  DAILY: "daily",
} as const;
export type PeriodicEnum = (typeof PeriodicEnum)[keyof typeof PeriodicEnum];

export function instanceOfPeriodicEnum(value: any): boolean {
  for (const key in PeriodicEnum) {
    if (Object.prototype.hasOwnProperty.call(PeriodicEnum, key)) {
      if (PeriodicEnum[key as keyof typeof PeriodicEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function PeriodicEnumFromJSON(json: any): PeriodicEnum {
  return PeriodicEnumFromJSONTyped(json, false);
}

export function PeriodicEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PeriodicEnum {
  return json as PeriodicEnum;
}

export function PeriodicEnumToJSON(value?: PeriodicEnum | null): any {
  return value as any;
}

export function PeriodicEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): PeriodicEnum {
  return value as PeriodicEnum;
}
